module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/1@2x_2f177e76bc515a05fbc7738a99852f77.png";